import { useState, useEffect } from 'react';

export interface BreakdownEntry {
    codeType: string;
    answerId: number;
    rubricPoints: number;
    category: string;
    displayText: string | null;
    codeValue?: string | null;
    isOriginal?: boolean | null;
}

export interface ScoringEventDto {
    id: number | null;
    score: number;
    acceptable: boolean;
    threshold: number;
    overallCategory: string;
    breakdown: BreakdownEntry[];
    scoringConfigId: number;
    computedAt: string;
    triggeredBy: string | null;
    computedForUserId: string | null;
}

function authHeaders(): HeadersInit {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${sessionStorage.getItem('authToken')}`,
    };
}

export function useLiveScore(
    sdCaseId: string | undefined,
    rubricVersionId: number | undefined,
    refetchKey: number,
): { liveScore: ScoringEventDto | null; loading: boolean } {
    const [liveScore, setLiveScore] = useState<ScoringEventDto | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!sdCaseId || rubricVersionId == null) return;
        setLoading(true);
        fetch(
            `/api/cqa-service/v1/grader-workitem/${encodeURIComponent(sdCaseId)}/score-preview?rubricVersionId=${rubricVersionId}`,
            { method: 'GET', headers: authHeaders() },
        )
            .then(r => {
                if (r.status === 204) return null;
                if (!r.ok) return null;
                return r.json();
            })
            .then((data: ScoringEventDto | null) => setLiveScore(data))
            .catch(() => setLiveScore(null))
            .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdCaseId, rubricVersionId, refetchKey]);

    return { liveScore, loading };
}
